import { requestBinary } from '@/api/http'

// 通过当前后端读取原文件，避免数据库有ID但文件位于另一环境，或浏览器缓存误判。
export async function templateCoverReadable (fileId) {
  if (typeof fileId !== 'string' || !/^[A-Za-z0-9_-]{1,64}$/.test(fileId)) throw new Error('原项目封面编号无效，请重新加载')
  let response
  try {
    response = await requestBinary({ url: '/jetlinks/file/' + fileId + '.png',
      params: { _templateCoverCheck: Date.now() }, timeout: 10000 })
  } catch (error) {
    // 登录、权限及其他明确请求错误保留原提示，不能当成缺图继续上传。
    if ([400, 404, 410].includes(error.status) || error.status >= 500 || ['TIMEOUT', 'NETWORK_ERROR'].includes(error.code)) return false
    throw error
  }
  if (!response || response.status !== 200 || !(response.data instanceof ArrayBuffer || ArrayBuffer.isView(response.data))) return false
  const data = response.data
  const bytes = data instanceof ArrayBuffer ? new Uint8Array(data) : new Uint8Array(data.buffer, data.byteOffset, data.byteLength)
  if (bytes.length < 33 || bytes.length > 1024 * 1024 || ![137, 80, 78, 71, 13, 10, 26, 10].every((value, i) => bytes[i] === value) ||
      String.fromCharCode(...bytes.slice(12, 16)) !== 'IHDR') return false
  const view = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength)
  const width = view.getUint32(16), height = view.getUint32(20)
  if (!width || !height || width > 1024 || height > 1024) return false
  if (typeof window !== 'undefined' && typeof window.createImageBitmap === 'function') {
    let bitmap
    try { bitmap = await window.createImageBitmap(new Blob([bytes], { type: 'image/png' })); return bitmap.width === width && bitmap.height === height }
    catch (_) { return false }
    finally { if (bitmap) bitmap.close() }
  }
  return true
}
